import { render, staticRenderFns } from "./companyContent.vue?vue&type=template&id=3f66aed8&scoped=true&"
import script from "./companyContent.vue?vue&type=script&lang=js&"
export * from "./companyContent.vue?vue&type=script&lang=js&"
import style0 from "./companyContent.vue?vue&type=style&index=0&id=3f66aed8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f66aed8",
  null
  
)

export default component.exports